import styled, {css} from 'styled-components'

export const StyledSectionTitle = styled.h3(
    ({theme: {typography}}) => css`
        ${typography.textMd};
        font-weight: 500;
    `
)

export const StyledDescription = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['500']};
        text-align: center;

        & button {
            cursor: pointer;
            text-decoration: underline;
            &:disabled {
                cursor: not-allowed;
            }
        }
    `
)

export const StyledExtensionRadioField = styled.label(
    ({theme: {spacing, palette, opacities, typography}}) => css`
        padding: ${spacing * 2}px;
        border-radius: 8px;
        border: 1px solid ${palette.neutral.black}${opacities['10']};
        width: 100%;
        display: flex;
        gap: ${spacing * 2}px;
        cursor: pointer;
        ${typography.textSm};

        &:has(input:checked) {
            border: 1px solid ${palette.primary['500']};
        }

        & p {
            font-weight: 500;
        }
        & small {
            color: ${palette.neutral['700']};
        }
    `
)
